const checkPhoneWithWhiteSpace = (phoneInput) => {
  var regex = /^[\+]?[0-9]+$/; // Regular expression to allow only numbers
  if (!regex.test(phoneInput)) {
    return false;
  }
  return true;
};

export default checkPhoneWithWhiteSpace;
